import React from 'react';
import {useIntl} from 'react-intl';
import styles from './billing-block.module.scss';

const InactiveCentralNotice = () => {
  const intl = useIntl();
  return (
    <div role="alert" className={styles.notice}>
      {intl.formatMessage({id: 'billingBlockInactiveCentral'})}
    </div>
  );
};

export default InactiveCentralNotice;
